import EventEmitter from '../utils/EventEmitter';
import dispatcher from '../dispatcher';

var eventEmitter = new EventEmitter();

var size = {
	width: 0,
	height: 0
}

var _windowSize = function() {
	return {
		width: document.body.clientWidth,
		height: document.body.clientHeight
	}
}

var _onResize = function() {
	size = _windowSize();
	eventEmitter.dispatch();
}

var _handleEvent = function(e) {
	if (e.type === 'resize:store-fire') {
		eventEmitter.dispatch();
	}
}

var _init = function() {
	_onResize();

	window.addEventListener('resize', _onResize, {passive: true});
	window.addEventListener('orientationchange', _onResize, {passive: true});
	window.addEventListener('load', _onResize, {passive: true});
	dispatcher.subscribe('resize', _handleEvent);
}

var getData = function() {
	return size;
}

_init();

export default {
	subscribe: eventEmitter.subscribe.bind(eventEmitter),
	unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
	getData: getData
}